import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Message } from '../../_models';
import { DocumentoService } from 'src/app/_services/documento.service';

@Component({
  selector: 'app-popup-messages',
  templateUrl: './popup-messages.component.html',
  styleUrls: ['./popup-messages.component.css']
})
export class PopupMessagesComponent implements OnInit {
  textButton: string;
  confirm: boolean;
  downloadSavePrint;
  type: string;
  htmlStr: string;

  constructor(
    private documentoService: DocumentoService,
    private dialogRef: MatDialogRef<PopupMessagesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Message) { }

  ngOnInit() {
    if (this.data.type === 'confirm') {
      this.confirm = true;
      this.textButton = 'SIM';
    } else {
      this.confirm = false;
      this.textButton = 'OK';
    }

    if (this.data.message.indexOf('tente salvá-lo no modo impressão') !== -1) {
      this.downloadSavePrint = true;
    } else {
      this.downloadSavePrint = false;
    }

    this.type = this.type = 'application/pdf';

    this.htmlStr = this.data.message;
  }

  getSavePrint() {
    this.documentoService.getSavePrint().subscribe(respData => {
      this.downLoadFile(respData, this.type);
    }, error => {

    });
  }

  downLoadFile(data: any, type: string) {
    let blob = new Blob([data], { type: type.toString() });
    let url = window.URL.createObjectURL(blob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed === 'undefined') {
      alert('Desative o bloqueador de pop-ups e tente novamente.');
    }
  }

  Confirm() {
    this.dialogRef.close(true);
  }

  closePopup() {
    this.dialogRef.close(false);
  }

  notConfirm() {
    this.dialogRef.close(false);
  }

}
